import React from "react";
import {toast} from "react-toastify";
import "./Toast.scss";
import "./SuccessToast.scss";
import {ToastBody} from "./ToastBody";
import {type ToastHandler} from "./types";

export const showSuccessToast: ToastHandler = ({id, title = "Success!", message, link, when}) =>
  toast.success(<ToastBody title={title} message={message} link={link} when={when} />, {
    closeButton: false,
    icon: false,
    toastId: id
  });
